import { useMemo, useState } from 'react';
import { Bundle, EmployeeType } from '@prisma/client';
import { SelectProps } from 'antd';
import { debounce } from 'lodash';

import { Auth } from '@app/web-components';

import { useFindBundle } from '../../../bundles';
import { EmployeeTypeRenderer } from '../../../common';

export type BundleSelectProps = {
  employeeType?: EmployeeType;
  isOwnedBundles?: boolean;
};

export const useBundleSelect = ({ employeeType, isOwnedBundles = false }: BundleSelectProps) => {
  const [contains, setContains] = useState('');
  const { user } = Auth.useUserAuth();
  const { data, isPending, isFetching } = useFindBundle<Bundle>({
    where: {
      isActive: true,
      name: {
        contains,
        mode: 'insensitive',
      },
      employeeType,
      ...(isOwnedBundles && {
        owners: {
          some: {
            ownerId: user?.id,
          },
        },
      }),
    },
    select: {
      id: true,
      name: true,
      employeeType: true,
      owners: {
        select: {
          ownerId: true,
        },
      },
    },
    orderBy: {
      createdOn: 'desc',
    },
  });

  const onSearch = useMemo(() => debounce(setContains, 300), []);

  const getProps = (props?: SelectProps): SelectProps => ({
    ...props,
    filterOption: false,
    loading: isPending || isFetching,
    options: data?.data.map((x) => ({
      value: x.id,
      label: (
        <div style={{ display: 'flex' }}>
          {x.name}
          <span style={{ marginLeft: 'auto' }}>
            <EmployeeTypeRenderer employeeType={x.employeeType} />
          </span>
        </div>
      ),
    })),
    showSearch: true,
    style: { ...props?.style, width: 600 },
    onSearch,
  });

  return { getProps };
};
